<template>
  <span class="hover-popover" @mouseenter="show" @mouseleave="hide" @focusin="show" @focusout="hide">
    <slot />
    <div v-if="open" ref="panel" class="md-tooltip hover-popover__panel" :class="popoverClass" :style="panelStyle">
      <slot name="content" />
    </div>
  </span>
</template>

<script>
// Mouseover statt md-tooltip: md-tooltip bindet seine Listener erst nach $nextTick an das urspruengliche Elternelement
// und blieb beim Kunden bei manchen Zeilen stumm (Trello 3b9GL2pS K/L, PAN03/BROT06Er). Hier haengen die Listener per Vue
// an der Zelle selbst; das Panel wird an den body gehaengt, damit Tabellen-Overflow es nicht abschneidet.
export default {
  name: "HoverPopover",
  props: {
    disabled: { type: Boolean, default: false },
    popoverClass: { type: String, default: "" },
  },
  data() {
    return { open: false, panelStyle: { top: "0px", left: "0px", visibility: "hidden" } };
  },
  watch: {
    disabled(value) {
      if (value) this.hide();
    },
  },
  updated() {
    // Inhalt waechst nach dem Laden (z. B. Lagerplaetze) - Position neu bestimmen
    if (this.open) this.place();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.hide, true);
    const panel = this.$refs.panel;
    if (panel && panel.parentNode) panel.parentNode.removeChild(panel);
  },
  methods: {
    show() {
      if (this.disabled || this.open) return;
      this.open = true;
      this.$emit("show");
      window.addEventListener("scroll", this.hide, true);
      this.$nextTick(() => {
        const panel = this.$refs.panel;
        if (!panel) return;
        document.body.appendChild(panel);
        this.place();
      });
    },
    hide() {
      window.removeEventListener("scroll", this.hide, true);
      this.open = false;
      this.panelStyle = { top: "0px", left: "0px", visibility: "hidden" };
    },
    place() {
      const panel = this.$refs.panel;
      if (!panel || panel.parentNode !== document.body) return;
      const target = this.$el.getBoundingClientRect();
      const gap = 10;
      const margin = 8;
      let top = target.top - panel.offsetHeight - gap;
      if (top < margin) top = target.bottom + gap;
      const left = Math.min(Math.max(margin, target.left + target.width / 2 - panel.offsetWidth / 2), window.innerWidth - panel.offsetWidth - margin);
      const next = { top: `${Math.round(top)}px`, left: `${Math.round(left)}px`, visibility: "visible" };
      if (next.top !== this.panelStyle.top || next.left !== this.panelStyle.left || this.panelStyle.visibility !== next.visibility) {
        this.panelStyle = next;
      }
    },
  },
};
</script>

<style>
.md-tooltip.hover-popover__panel {
  position: fixed;
  z-index: 1100;
  height: auto;
  opacity: 1;
  transform: none;
}
</style>
